import './accordion.scss';

class Accordion {
    constructor (element) {
        this.accordion = element;
        this.accordionCheckbox = this.accordion.querySelectorAll('[data-accordion="checkbox"]');
        this.accordionButton = this.accordion.querySelectorAll('[data-accordion="button"]');
        this.accordionContent = this.accordion.querySelectorAll('[data-accordion="content"]');
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.accordionButton.forEach(button => {
            button.addEventListener('click', () => {
                this.toggleContent(button);
            });

            button.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    this.toggleContent(button);
                    this.toggleCheckbox(button);
                }
            });
        });
    }

    toggleContent (button) {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isExpanded);

        this.accordionContent.forEach(content => {
            if (content.previousElementSibling === button) {
                content.hidden = isExpanded;

                if (!isExpanded) {
                    button.classList.add('accordion__item-button--is-active');
                    content.classList.add('accordion__item-content--is-active');
                } else {
                    button.classList.remove('accordion__item-button--is-active');
                    content.classList.remove('accordion__item-content--is-active');
                }
            }
        });
    }

    toggleCheckbox (button) {
        this.accordionCheckbox.forEach(checkbox => {
            if (checkbox.nextElementSibling === button) {
                checkbox.checked = !checkbox.checked;
            }
        });
    }
}

export { Accordion };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;
    if ($context) {
        const $$accordion = $context.querySelectorAll('[data-accordion="root"]');

        for (let i = 0; i < $$accordion.length; i++) {
            const $accordion = new Accordion($$accordion[i]);
            $accordion.initialize();
        }
    }
});
